import { Text } from '@/ui-kit'
import { formatNumber } from '@/utils'
import { clsx } from 'clsx'
import type { LeaderboardEntry } from '../api/models'

type LeaderboardMobileListProps = {
  entries: LeaderboardEntry[]
  highlightUserId?: string | null
}

export const LeaderboardMobileList = ({ entries, highlightUserId }: LeaderboardMobileListProps) => {
  return (
    <ul className="mt-4 space-y-2">
      {entries.map((entry) => {
        const isHighlighted = !!highlightUserId && entry.id === highlightUserId
        return (
          <li
            key={entry.id}
            className={clsx(
              'relative flex flex-col gap-1 rounded-2xl border border-solid p-4 transition',
              isHighlighted ? 'border-orange' : 'border-gray-100'
            )}
          >
            <div className="flex items-center justify-between">
              <Text className="font-semibold">#{entry.rank}</Text>
              <Text className="text-gray-90" type="body3-regular">
                {formatNumber(Math.round(entry.points || 0), 0)} pts
              </Text>
            </div>
            <Text>{entry.id || '-'}</Text>
          </li>
        )
      })}
    </ul>
  )
}
